// extracted by mini-css-extract-plugin
module.exports = {"imgBtn":"Navbar_imgBtn__1fb6g","border":"Navbar_border__3r7Or"};